import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LayoutType } from '~/enums/LayoutType';

interface State {
  contentTabLayout: LayoutType;
  isDocumentDetailsPanelOpen: boolean;
}

export const initialState: State = {
  contentTabLayout: LayoutType.TwoColumn,
  isDocumentDetailsPanelOpen: true,
};

export default createSlice({
  name: 'documentsViewPage',
  initialState,
  selectors: {
    selectContentTabLayout: (state) => state.contentTabLayout,
    selectIsDocumentDetailsPanelOpen: (state) =>
      state.isDocumentDetailsPanelOpen,
  },
  reducers: {
    setContentTabLayout: (state, action: PayloadAction<LayoutType>) => {
      state.contentTabLayout = action.payload;
    },
    setDocumentDetailsPanelOpen: (state, action: PayloadAction<boolean>) => {
      state.isDocumentDetailsPanelOpen = action.payload;
    },
  },
});
